export interface CardsTheme {
  shadow: any;
  borderRadius: any;
}

export default {
  shadow: ({ theme }: any) => theme.accents.floatingShadow,
  borderRadius: ({ theme }: any) => theme.common.borderRadius,
} as CardsTheme;
